import getSocketUpdates from '../../../../shared/requests/socket-updates';

export const getChatUpdatesUseCase = async (lastUpdatedTimestamp: number) => {
  return getSocketUpdates(lastUpdatedTimestamp);
};
